import React from "react";

const InfectiousDonorsDesktop = React.lazy(() => import("./ui/InfectiousDonors"));

export const InfectiousDonorsPage = () => {
  return <InfectiousDonorsDesktop />;
};
